import { useSelector } from "react-redux";
import { handleValidateCodevalue } from "../Utility/constant";
import CommonEmail from "./CommonEmail";
import { StyledLeadContainer, StyledSubHeader } from "./Styled";
import TextFiledWithLabel from "./TextFieldWithLabel";
import NumericTextField from "./NumericTextfield";

const CommonComm = ({required=false ,requiredValue, isDetailPage,isViewMode,handleOnChange , isRequired,state} ) => {

  const internationalise = useSelector(state => state?.internationalise?.currentHashMapData)

  return (
    <>
    
    <StyledSubHeader>
    {handleValidateCodevalue(internationalise,'COMMON_COMM_DETAILS')} 
    </StyledSubHeader>
    <StyledLeadContainer>
    <NumericTextField
    required = {required}
    isDetailPage = {isDetailPage}
    isViewMode={isViewMode}
    name = 'phone'
    value={state?.phone}
    isRequired={requiredValue?.phone || false}
    handleOnChange={handleOnChange}
    />
    <NumericTextField
    isRequired={isRequired}
    isDetailPage = {isDetailPage}
    isViewMode={isViewMode}
    name = 'telephone'
    label = {handleValidateCodevalue(internationalise,'COMMON_COMM_ALT_PHONE_NUMBER')}
    value={state?.telephone}
    handleOnChange={handleOnChange}
    />
    <CommonEmail
    required = {required}
    isDetailPage = {isDetailPage}
    isViewMode={isViewMode}
    name = 'email'
    value = {state?.email}
    isRequired={requiredValue?.email || false}
    handleOnChange={handleOnChange}
    />
    <TextFiledWithLabel
    sx = {{visibility : 'hidden'}}
    />
</StyledLeadContainer>
</>)
}

export default CommonComm

